var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelivered3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4974 3.66699V22.0003C27.4974 24.017 25.8474 25.667 23.8307 25.667H3.66406V13.9703C5.0024 15.5653 7.05578 16.5553 9.32911 16.5003C11.1808 16.4637 12.8491 15.7487 14.0957 14.557C14.6641 14.0803 15.1408 13.4753 15.5074 12.8153C16.1674 11.697 16.5341 10.3769 16.4974 9.00194C16.4424 6.85694 15.4891 4.96866 14.0041 3.66699H27.4974Z",
    stroke: "#219EBC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3307 25.667V31.167C40.3307 34.2103 37.8741 36.667 34.8307 36.667H32.9974C32.9974 34.6503 31.3474 33.0003 29.3307 33.0003C27.3141 33.0003 25.6641 34.6503 25.6641 36.667H18.3307C18.3307 34.6503 16.6807 33.0003 14.6641 33.0003C12.6474 33.0003 10.9974 34.6503 10.9974 36.667H9.16406C6.12073 36.667 3.66406 34.2103 3.66406 31.167V25.667H23.8307C25.8474 25.667 27.4974 24.017 27.4974 22.0003V9.16699H30.8708C32.1908 9.16699 33.4008 9.88201 34.0608 11.0187L37.1957 16.5003H34.8307C33.8224 16.5003 32.9974 17.3253 32.9974 18.3337V23.8337C32.9974 24.842 33.8224 25.667 34.8307 25.667H40.3307Z",
    stroke: "#219EBC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 40.3333C16.6917 40.3333 18.3333 38.6917 18.3333 36.6667C18.3333 34.6416 16.6917 33 14.6667 33C12.6416 33 11 34.6416 11 36.6667C11 38.6917 12.6416 40.3333 14.6667 40.3333Z",
    stroke: "#219EBC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3307 40.3333C31.3558 40.3333 32.9974 38.6917 32.9974 36.6667C32.9974 34.6416 31.3558 33 29.3307 33C27.3057 33 25.6641 34.6416 25.6641 36.6667C25.6641 38.6917 27.3057 40.3333 29.3307 40.3333Z",
    stroke: "#219EBC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3333 22V25.6667H34.8333C33.825 25.6667 33 24.8417 33 23.8333V18.3333C33 17.325 33.825 16.5 34.8333 16.5H37.1983L40.3333 22Z",
    stroke: "#219EBC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5026 9.16634C16.5026 11.3663 15.531 13.328 14.0093 14.6663C12.7076 15.803 11.0209 16.4997 9.16927 16.4997C5.1176 16.4997 1.83594 13.218 1.83594 9.16634C1.83594 6.85634 2.89927 4.78468 4.58594 3.44635C5.85094 2.43802 7.44594 1.83301 9.16927 1.83301C13.2209 1.83301 16.5026 5.11467 16.5026 9.16634Z",
    stroke: "#219EBC",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6276 6.875V9.625L7.33594 11",
    stroke: "#219EBC",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivered3);
export default __webpack_public_path__ + "static/media/delivered3.05ebd0d2d6f3488ac6da27315cb3374f.svg";
export { ForwardRef as ReactComponent };